<template>
    <div>
        <Subtitle :subtitle='leftObj.subTitle' style="height: 9%;padding-top: 3%" />
        <div class="boxMain" style="height: 89%;padding-top: 1%">
            <div class="onlineBox">
                <div class="onlineUnitBox">
                    <dv-digital-flop :config="item" v-for="(item, index) in leftObj.flopList" :key="index" />
                </div>
                <div class="labelName">飞行设备在线数</div>
            </div>
            <dv-scroll-board :config="leftObj.config" style="height: 80%;" />
        </div>
    </div>
</template>

<script>
import Subtitle from '@/components/header/subTitle.vue'
export default {
    props: {
        leftObj: {
            typeof: Object
        }
    },
    components: {
        Subtitle
    },
    data() {
        return {
            
        };
    },
    computed: {},
    watch: {},
    created() {},
    mounted() {},
    methods: { },
};
</script>

<style lang='scss' scoped>
.onlineBox {
    width: 100%;
    height: 20%;
    padding-top: 0.1vh;
    box-sizing: border-box;
    .onlineUnitBox {
        width: 379px;
        height: 65px;
        background: url('../../../assets/dataScreen/onlineUnit.png') no-repeat;
        background-size: 100% 100%;
        margin: 0 auto;
        display: flex;
        & div {
            width: 16.66%;
            height: 100%;
        }
    }
    .labelName {
        text-align: center;
        margin-top: 0.5vh;
    }
}
</style>